module.exports = __webpack_public_path__ + "static/img/3.0ae4006.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.gif
// module id = gsrU
// module chunks = 13